import { Field, Model } from 'serialize-ts';
import { ReferencePriceTypes } from '~shared/models/reference-price-types.enum';

@Model()
export class ReferencePrice {
  @Field()
  netPrice: number;

  @Field()
  grossPrice: number;

  @Field()
  vatValue: number;

  @Field()
  currency: string;

  @Field()
  unit: string;

  @Field()
  discountPercentage: string;

  @Field()
  priceType: ReferencePriceTypes;
}
